import { useState, useEffect, useMemo } from "react";
import { nils, tofeth } from "../../utils/utils.jsx";
import ERC20base from "../../contracts/v2/ERC20base.js";
import { useAppContext } from "../../App.jsx";

export const useVaultBalances = (vault) => {
  const appcon = useAppContext();
  const { tok_to_usd_val } = appcon;

  const [balances, set_balances] = useState({
    DEZ: 0,
    WETH: 0,
    SGC: 0,
  });
  const [loading, set_loading] = useState(false);
  const [error, set_error] = useState(null);

  const tokens = useMemo(() => ["DEZ", "WETH", "SGC"], []);

  const balances_usd = useMemo(() => {
    return {
      DEZ: tok_to_usd_val(balances.DEZ, "DEZ") || 0,
      WETH: tok_to_usd_val(balances.WETH, "WETH") || 0,
      SGC: 0, // SGC doesn't have USD conversion
    };
  }, [balances, tok_to_usd_val]);

  const fetchBalances = async () => {
    if (nils(vault)) {
      set_balances({ DEZ: 0, WETH: 0, SGC: 0 });
      return;
    }

    set_loading(true);
    set_error(null);

    try {
      const newBalances = {};

      for (const token of tokens) {
        try {
          const contract = await ERC20base.get_contract(token);
          const rawBalance = await contract.balanceOf(vault);
          const formattedBalance = parseFloat(tofeth(rawBalance.toString()));
          newBalances[token] = formattedBalance;
        } catch (tokenError) {
          console.warn(`Failed to fetch ${token} balance:`, tokenError);
          newBalances[token] = 0;
        }
      }

      set_balances(newBalances);
    } catch (err) {
      console.error("Error fetching vault balances:", err);
      set_error(err.message);
      set_balances({ DEZ: 0, WETH: 0, SGC: 0 });
    } finally {
      set_loading(false);
    }
  };

  const refetch = () => {
    fetchBalances();
  };

  useEffect(() => {
    fetchBalances();
  }, [vault, tokens]);

  return {
    balances,
    balances_usd,
    loading,
    error,
    refetch,
  };
};